export const shouldHideOption = (attrTags, option) => {
  const [, , , presentationTags] = option.tags;

  return presentationTags.some((presentationTag) => {
    const pcModelAttrTag = attrTags.find(
      (attrTag) => attrTag.name === presentationTag.name,
    );
    return evaluatePresentationTag(pcModelAttrTag, presentationTag);
  });
};

const evaluatePresentationTag = (attrTag, presentationTag) => {
  if (!attrTag) return false;

  if (attrTag.name !== presentationTag.name) return false;

  const operatorsMapping = {
    is: evaluateIs,
    not: evaluateNot,
    in: evaluateIn,
    min: evaluateMin,
    max: evaluateMax,
  };

  if (Object.keys(operatorsMapping).includes(presentationTag.operator)) {
    return operatorsMapping[presentationTag.operator](attrTag, presentationTag);
  }

  return false;
};

const evaluateIs = (attrTag, presentationTag) =>
  attrTag.value === presentationTag.value;

const evaluateNot = (attrTag, presentationTag) =>
  attrTag.value !== presentationTag.value;

const evaluateIn = (attrTag, presentationTag) =>
  presentationTag.value.split(';').includes(attrTag.value);

const evaluateMin = (attrTag, presentationTag) =>
  Number(presentationTag.value) <= Number(attrTag.value);

const evaluateMax = (attrTag, presentationTag) =>
  Number(presentationTag.value) >= Number(attrTag.value);
